module.exports = __webpack_public_path__ + "static/media/mgk_ls_img.77303c45.png";